import React from 'react';
import uuid from 'uuid';
import PropTypes from 'prop-types';
import GlideItem from '../GlideItem';
import GlideControls from '../GlideControls';
import GlideConfigScript from '../GlideConfigScript';

/*
 * Only use this carousel in components that will not/cannot be hydrated on the client side.
 *
 * Library used: https://glidejs.com/
 *
 */

const GlideCarousel = ({ withoutControls, children, ...rest }) => {
  const slideCount = React.Children.count(children);
  if (slideCount < 1) {
    return false;
  }
  const carouselId = uuid.v4();
  const carouselConfig = {
    carouselId,
    slideCount,
    ...rest,
  };

  return (
    <React.Fragment>
      <div id={carouselId}>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {React.Children.map(children, child => (
              <GlideItem>
                {child}
              </GlideItem>
            ))
            }
          </ul>
        </div>
        <GlideControls withoutControls={withoutControls} slideCount={slideCount} />
      </div>
      <GlideConfigScript {...carouselConfig} />
    </React.Fragment>
  );
};

GlideCarousel.propTypes = {
  withoutControls: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default GlideCarousel;
